import { useState, useEffect } from "react";
import { MEDIA_MOBILE_BREAKPOINT } from "../config/constants";

export const useIsMedia = () => {
  const [screenSize, setScreenSize] = useState<{ width: number; height: number }>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    isMobile: screenSize.width < MEDIA_MOBILE_BREAKPOINT * 16,
    isDesktop: screenSize.width >= MEDIA_MOBILE_BREAKPOINT * 16,
  };
};
